'use client'

import { useRouter } from 'next/navigation'
import { useTranslations } from 'next-intl'

import { MButton } from '@/_components/medante/ui/m-button'
import { pushPathWithHash } from '@/_lib/next-link-href'

import MedanteValuesDesktopSvg from '../_images/medante-values-desktop.svg'
import MedanteValuesMobileSvg from '../_images/medante-values-mobile.svg'

import ZJobsEyebrow from './z-jobs-eyebrow'

const AJobsSectionValues = () => {
	const t = useTranslations('pages.letsMakeWorldHealthier.values')
	const router = useRouter()
	const alt = t('imageAlt')

	return (
		<section
			id='nase-hodnoty'
			className='relative pt-12 lg:pt-18 lg:pt-24 pb-4 lg:pb-22 lg:pb-28 bg-m-fuchsia text-white'
		>
			<div className='wrapper2 grid grid-cols-1 lg:grid-cols-2 lg:gap-10 gap-8 lg:items-start'>
				<div className='flex flex-col justify-center'>
					<ZJobsEyebrow>{t('eyebrow')}</ZJobsEyebrow>
					<h2 className='type-medante-h1'>{t('title')}</h2>
					<div className='mt-4 text-base font-light max-w-md'>
						<p>{t('text')}</p>
					</div>
					<div className='mt-6 lg:mt-8'>
						<MButton
							onClick={() => {
								pushPathWithHash(router, '/kariera#pozicie')
							}}
							variant='white'
						>
							{t('joinUs')}
						</MButton>
					</div>
				</div>

				{/* Desktop: pevný max box 675×445, SVG scaleuje vnútri (preserveAspectRatio meet) */}
				<div className='hidden min-w-0 lg:flex md:w-full md:justify-center'>
					<div className='mx-auto  min-h-0 overflow-visible'>
						<MedanteValuesDesktopSvg
							className='block h-full min-h-0 min-w-0'
							preserveAspectRatio='xMidYMid meet'
							role='img'
							aria-label={alt}
						/>
					</div>
				</div>
			</div>

			{/* Mobile: mimo wrapper2 — obrázok ukotvený vpravo (right:0), časť vľavo orezaná overflowom */}
			<div className='relative h-[425px] w-screen max-w-[100vw] lg:hidden'>
				<MedanteValuesMobileSvg
					className='absolute right-0 top-1/2 -mt-10 z-10 max-w-[90vw] w-auto -translate-y-1/2'
					preserveAspectRatio='xMaxYMid meet'
					role='img'
					aria-label={alt}
				/>
			</div>
		</section>
	)
}

export default AJobsSectionValues
